import styled from 'styled-components';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import SaveIcon from '@material-ui/icons/Save';
import { useTranslation } from 'react-i18next';
import { Button } from '../../Buttons';

import ParameterPanel from '../ParameterPanel';

const FlexContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    max-width: 140px;
`;
const HelperText = styled.div`
    font-size: 90%;
    font-style: italic;
    line-height: 1.1;
    padding: 2px 4px;
    color: ${({ $warning }) => ($warning ? '#e42000' : 'inherit')};
`;
const HelperButton = ({ helperText, warning, ...props }) => {
    return (
        <FlexContainer>
            <Button {...props} />
            <HelperText $warning={warning}>{helperText}</HelperText>
        </FlexContainer>
    );
};

const GameParameters = ({
    formValues,
    handleInputChange,
    handleTryOutSettings,
    handleFinal,
    language,
    gameConfig,
    game,
    busy,
    fetching,
    gameStatus,
}) => {
    const { t } = useTranslation();

    const { attempts, maxAttempts } = gameStatus;
    const attemptsLeft = maxAttempts - attempts;

    const presetParameters = Object.entries(game)
        .filter(([key, value]) => {
            const paramConfig = gameConfig[key];

            return paramConfig?.type === 'preset';
        })
        .reduce((prev, cur) => {
            const [key, value] = cur;
            return { ...prev, [key]: value };
        }, {});

    return (
        <ParameterPanel
            variant="game"
            title="Game parameters"
            buttons={[
                <HelperButton
                    key="try"
                    disabled={busy || fetching || attemptsLeft < 2}
                    onClick={handleTryOutSettings}
                    startIcon={<PlayArrowIcon />}
                    color="primary"
                    variant="outlined"
                >
                    {t('buttons.tryout')}
                </HelperButton>,
                <HelperButton
                    key="final"
                    disabled={busy || fetching}
                    onClick={handleFinal}
                    startIcon={<SaveIcon />}
                    color="primary"
                >
                    {t('buttons.final')}
                </HelperButton>,
                <HelperText key="help" $warning={attemptsLeft < 3}>
                    {t('game.attemptsLeft', { count: attemptsLeft })}
                </HelperText>,
            ]}
            formValues={formValues}
            readOnlyValues={presetParameters}
            readOnlyPanelTitle={t('game.Fixed parameters')}
            gameConfig={gameConfig}
            handleInputChange={handleInputChange}
            language={language}
        />
    );
};

export default GameParameters;
